import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-swiss-white">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 bg-swiss-black flex items-center justify-center animate-pulse">
            <span className="text-swiss-white font-bold text-[11px]">D</span>
          </div>
          <span className="text-[14px] text-swiss-gray-500">Loading...</span>
        </div>
      </div>
    )
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Authenticated
  return <>{children}</>
}

export default ProtectedRoute
